export interface TickerReportConfig {
  ticker: string;
  accent: string;
}

export const tickerReports: TickerReportConfig[] = [
  { ticker: 'MSFT', accent: '#5E5E5E' },
  { ticker: 'AAPL', accent: '#000000' },
  { ticker: 'RDDT', accent: '#FF4500' },
  { ticker: 'WMT', accent: '#0071CE' },

  { ticker: 'NVDA', accent: '#76B900' },
  { ticker: 'GOOGL', accent: '#4285F4' },
  { ticker: 'AMZN', accent: '#FF9900' },
  { ticker: 'META', accent: '#0866FF' },
  { ticker: 'AVGO', accent: '#CC092F' },
  { ticker: 'TSLA', accent: '#E82127' },
  { ticker: 'BRK-B', accent: '#003B70' },
  { ticker: 'LLY', accent: '#D52B1E' },
  { ticker: 'V', accent: '#1A1F71' },
  { ticker: 'JPM', accent: '#117ACA' },
  { ticker: 'WMT', accent: '#0071CE' },
  { ticker: 'ORCL', accent: '#F80000' },
  { ticker: 'MA', accent: '#EB001B' },
  { ticker: 'NFLX', accent: '#E50914' },
  { ticker: 'COST', accent: '#E31837' },
  { ticker: 'HD', accent: '#F96302' },

  { ticker: 'PG', accent: '#003DA5' },
  { ticker: 'JNJ', accent: '#D51920' },
  { ticker: 'ABBV', accent: '#071D49' },
  { ticker: 'CRM', accent: '#032D60' },
  { ticker: 'BAC', accent: '#012169' },
  { ticker: 'KO', accent: '#F40009' },
  { ticker: 'CVX', accent: '#0066B3' },
  { ticker: 'MRK', accent: '#007A33' },
  { ticker: 'AMD', accent: '#ED1C24' },
  { ticker: 'PEP', accent: '#004B93' },
  { ticker: 'TMO', accent: '#007C91' },
  { ticker: 'CSCO', accent: '#049FD9' },
  { ticker: 'ACN', accent: '#A100FF' },
  { ticker: 'MCD', accent: '#FFC72C' },
  { ticker: 'ABT', accent: '#009CDE' },
  { ticker: 'LIN', accent: '#005EB8' },
  { ticker: 'ADBE', accent: '#FA0F00' },
  { ticker: 'DIS', accent: '#113CCF' },
  { ticker: 'INTU', accent: '#365EBF' },
  { ticker: 'IBM', accent: '#0F62FE' },

  { ticker: 'QCOM', accent: '#3253DC' },
  { ticker: 'TXN', accent: '#CC0000' },
  { ticker: 'AMGN', accent: '#0063A3' },
  { ticker: 'INTC', accent: '#0071C5' },
  { ticker: 'HON', accent: '#F47B20' },
  { ticker: 'CAT', accent: '#FFCD11' },
  { ticker: 'UNP', accent: '#005DAA' },
  { ticker: 'GE', accent: '#0875C1' },
  { ticker: 'BA', accent: '#0033A0' },
  { ticker: 'RTX', accent: '#002D62' },

  { ticker: 'GS', accent: '#7399C6' },
  { ticker: 'MS', accent: '#002C5F' },
  { ticker: 'C', accent: '#056DAE' },
  { ticker: 'WFC', accent: '#D71E28' },
  { ticker: 'BLK', accent: '#000000' },
  { ticker: 'SCHW', accent: '#00A0DF' },
  { ticker: 'AXP', accent: '#006FCF' },
  { ticker: 'USB', accent: '#005EB8' },
  { ticker: 'COF', accent: '#D03027' },
  { ticker: 'PYPL', accent: '#003087' },

  { ticker: 'CRM', accent: '#032D60' },
  { ticker: 'NOW', accent: '#81B5A1' },
  { ticker: 'PLTR', accent: '#101820' },
  { ticker: 'SNOW', accent: '#29B5E8' },
  { ticker: 'PANW', accent: '#FA582D' },
  { ticker: 'CRWD', accent: '#E01E3C' },
  { ticker: 'NET', accent: '#F38020' },
  { ticker: 'DDOG', accent: '#632CA6' },
  { ticker: 'MDB', accent: '#00ED64' },
  { ticker: 'ORCL', accent: '#F80000' },

  { ticker: 'UBER', accent: '#000000' },
  { ticker: 'ABNB', accent: '#FF5A5F' },
  { ticker: 'BKNG', accent: '#003580' },
  { ticker: 'SPOT', accent: '#1DB954' },
  { ticker: 'DASH', accent: '#FF3008' },
  { ticker: 'LYFT', accent: '#FF00BF' },
  { ticker: 'SQ', accent: '#000000' },
  { ticker: 'SHOP', accent: '#95BF47' },
  { ticker: 'COIN', accent: '#0052FF' },
  { ticker: 'HOOD', accent: '#00C805' },

  { ticker: 'NKE', accent: '#111111' },
  { ticker: 'SBUX', accent: '#00704A' },
  { ticker: 'TGT', accent: '#CC0000' },
  { ticker: 'LOW', accent: '#004990' },
  { ticker: 'TJX', accent: '#E31837' },
  { ticker: 'LULU', accent: '#000000' },
  { ticker: 'MELI', accent: '#FFE600' },
  { ticker: 'EL', accent: '#000000' },
  { ticker: 'CMG', accent: '#A6192E' },
  { ticker: 'YUM', accent: '#E31837' },

  { ticker: 'XOM', accent: '#ED1C24' },
  { ticker: 'COP', accent: '#E31837' },
  { ticker: 'SLB', accent: '#0072CE' },
  { ticker: 'OXY', accent: '#003DA5' },
  { ticker: 'NEE', accent: '#00AEEF' },
  { ticker: 'DUK', accent: '#005EB8' },
  { ticker: 'SO', accent: '#00AEEF' },
  { ticker: 'AMT', accent: '#009CDE' },
  { ticker: 'PLD', accent: '#005596' },
  { ticker: 'SPG', accent: '#005EB8' },

  { ticker: 'UNH', accent: '#002677' },
  { ticker: 'CVS', accent: '#CC0000' },
  { ticker: 'ISRG', accent: '#0072CE' },
  { ticker: 'GILD', accent: '#0072CE' },
  { ticker: 'VRTX', accent: '#00857C' },
  { ticker: 'REGN', accent: '#003B5C' },
  { ticker: 'ZTS', accent: '#0072CE' },
  { ticker: 'CI', accent: '#003B71' },
  { ticker: 'HUM', accent: '#0072CE' },
  { ticker: 'BSX', accent: '#0072CE' },
];
